'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherCheckCheck } from '@subframe/core';
import { useRouter } from 'next/navigation';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { CATEGORY_LABEL } from '@/shared/constants/notificationCategories';
import type { FonteNotificacoes, NotificacaoCategoria, NotificacaoItem } from '@/types/notificationBell/types';
import { categoryFilterChanged, markAllNotificationsAsRead, markNotificationAsRead, selectActiveTab, selectAvailableCategories, selectCategoryFilter, selectFilteredItems, selectFilteredItemsByEntityType, selectUnreadCount, selectUnreadCountByEntityType, tabChanged } from '../store';
import { NotificationEmptyState } from './NotificationEmptyState';
import { NotificationItem } from './NotificationItem';
interface NotificationDropdownProps {
  fonte: FonteNotificacoes;
  onlyEntityType?: 'ConversaPendencia';
  onItemClick?: (item: NotificacaoItem) => void;
  itemAtivavel?: (item: NotificacaoItem) => boolean;
  onRequestClose: () => void;
}
export function NotificationDropdown(t0) {
  const $ = _c(62);
  const {
    fonte,
    onlyEntityType,
    onItemClick,
    itemAtivavel,
    onRequestClose
  } = t0;
  const dispatch = useAppDispatch();
  const router = useRouter();
  const activeTab = useAppSelector(selectActiveTab);
  let t1;
  if ($[0] !== fonte || $[1] !== onlyEntityType) {
    t1 = state => onlyEntityType ? selectFilteredItemsByEntityType(state, fonte, onlyEntityType) : selectFilteredItems(state, fonte);
    $[0] = fonte;
    $[1] = onlyEntityType;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const items = useAppSelector(t1);
  let t2;
  if ($[3] !== fonte || $[4] !== onlyEntityType) {
    t2 = state_0 => onlyEntityType ? selectUnreadCountByEntityType(state_0, fonte, onlyEntityType) : selectUnreadCount(state_0, fonte);
    $[3] = fonte;
    $[4] = onlyEntityType;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const unreadCount = useAppSelector(t2);
  let t3;
  if ($[6] !== fonte) {
    t3 = state_1 => selectAvailableCategories(state_1, fonte);
    $[6] = fonte;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const availableCategories = useAppSelector(t3);
  const categoryFilter = useAppSelector(selectCategoryFilter);
  const scoped = Boolean(onlyEntityType);
  const mostraVerTodas = !scoped && fonte === "workspace";
  let t4;
  if ($[8] !== dispatch || $[9] !== fonte || $[10] !== items || $[11] !== scoped) {
    t4 = () => {
      if (scoped) {
        items.filter(_temp).forEach(item_0 => {
          dispatch(markNotificationAsRead({
            id: item_0.id,
            fonte
          }));
        });
        return;
      }
      dispatch(markAllNotificationsAsRead(fonte));
    };
    $[8] = dispatch;
    $[9] = fonte;
    $[10] = items;
    $[11] = scoped;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const handleMarkAll = t4;
  let t5;
  if ($[13] !== onRequestClose || $[14] !== router) {
    t5 = () => {
      onRequestClose();
      router.push("/notificacoes");
    };
    $[13] = onRequestClose;
    $[14] = router;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const handleVerTodas = t5;
  let t6;
  if ($[16] !== dispatch || $[17] !== fonte || $[18] !== onItemClick || $[19] !== onRequestClose) {
    t6 = item_1 => {
      onItemClick?.(item_1);
      if (!item_1.lida) {
        dispatch(markNotificationAsRead({
          id: item_1.id,
          fonte
        }));
      }
      onRequestClose();
    };
    $[16] = dispatch;
    $[17] = fonte;
    $[18] = onItemClick;
    $[19] = onRequestClose;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  const handleItemClick = t6;
  let t7;
  if ($[21] !== dispatch) {
    t7 = cat => {
      dispatch(categoryFilterChanged(cat));
    };
    $[21] = dispatch;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  const handleCategoryClick = t7;
  const t8 = scoped ? "Lembretes" : "Notifica\xE7\xF5es";
  let t9;
  if ($[23] !== unreadCount) {
    t9 = unreadCount > 0 && <span className="bg-error-50 text-error-600 border-error-200 ml-2 rounded-full border px-[7px] py-[1px] text-[11px] leading-none font-semibold">{unreadCount > 99 ? "99+" : unreadCount} novas</span>;
    $[23] = unreadCount;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t8 || $[26] !== t9) {
    t10 = <span className="text-default-font flex items-center text-[15px] font-bold">{t8}{t9}</span>;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== handleMarkAll || $[29] !== unreadCount) {
    t11 = unreadCount > 0 && <button type="button" onClick={handleMarkAll} className="text-brand-600 hover:bg-brand-50 flex items-center gap-[5px] rounded-md px-1 py-[2px] text-xs font-medium transition-colors"><FeatherCheckCheck className="h-[14px] w-[14px]" />Marcar todas como lidas</button>;
    $[28] = handleMarkAll;
    $[29] = unreadCount;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t10 || $[32] !== t11) {
    t12 = <div className="flex items-center justify-between px-4 pt-[14px]">{t10}{t11}</div>;
    $[31] = t10;
    $[32] = t11;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = ["unread", "all"];
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== activeTab || $[36] !== dispatch) {
    t14 = <div className="flex gap-[2px] border-b border-neutral-100 px-4 pt-[10px]">{(t13 as const).map(t => <button key={t} type="button" onClick={() => dispatch(tabChanged(t))} className={`-mb-px rounded-t border-b-2 px-3 py-[6px] text-[13px] font-medium transition-colors ${activeTab === t ? "text-brand-600 border-brand-600" : "text-subtext-color border-transparent"}`}>{t === "unread" ? "N\xE3o lidas" : "Todas"}</button>)}</div>;
    $[35] = activeTab;
    $[36] = dispatch;
    $[37] = t14;
  } else {
    t14 = $[37];
  }
  let t15;
  if ($[38] !== availableCategories || $[39] !== categoryFilter || $[40] !== handleCategoryClick || $[41] !== scoped) {
    t15 = !scoped && availableCategories.length > 1 && <div className="scrollbar-hidden flex gap-[6px] overflow-x-auto border-b border-neutral-100 px-4 py-[8px]"><button type="button" onClick={() => handleCategoryClick(null)} className={`shrink-0 rounded-md px-[8px] py-[3px] text-[11px] font-medium transition-colors ${categoryFilter === null ? "bg-brand-100 text-brand-700" : "text-subtext-color hover:bg-neutral-100"}`}>Todas</button>{availableCategories.map(cat_0 => <button key={cat_0} type="button" onClick={() => handleCategoryClick(cat_0)} className={`shrink-0 rounded-md px-[8px] py-[3px] text-[11px] font-medium transition-colors ${categoryFilter === cat_0 ? "bg-brand-100 text-brand-700" : "text-subtext-color hover:bg-neutral-100"}`}>{CATEGORY_LABEL[cat_0]}</button>)}</div>;
    $[38] = availableCategories;
    $[39] = categoryFilter;
    $[40] = handleCategoryClick;
    $[41] = scoped;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  let t16;
  if ($[43] !== activeTab || $[44] !== fonte || $[45] !== handleItemClick || $[46] !== itemAtivavel || $[47] !== items || $[48] !== onItemClick || $[49] !== scoped) {
    t16 = items.length === 0 ? <NotificationEmptyState tab={activeTab} scoped={scoped} /> : items.map(item_2 => <NotificationItem key={item_2.id} item={item_2} fonte={fonte} scoped={scoped} onActivate={onItemClick && (itemAtivavel?.(item_2) ?? true) ? () => handleItemClick(item_2) : undefined} />);
    $[43] = activeTab;
    $[44] = fonte;
    $[45] = handleItemClick;
    $[46] = itemAtivavel;
    $[47] = items;
    $[48] = onItemClick;
    $[49] = scoped;
    $[50] = t16;
  } else {
    t16 = $[50];
  }
  let t17;
  if ($[51] !== t16) {
    t17 = <div className="max-h-[380px] overflow-y-auto">{t16}</div>;
    $[51] = t16;
    $[52] = t17;
  } else {
    t17 = $[52];
  }
  let t18;
  if ($[53] !== handleVerTodas || $[54] !== mostraVerTodas) {
    t18 = mostraVerTodas ? <div className="flex justify-center border-t border-neutral-100 px-4 py-[10px]"><button type="button" onClick={handleVerTodas} className="text-brand-600 hover:bg-brand-50 rounded-md px-2 py-1 text-[13px] font-medium transition-colors">Ver todas as notificações →</button></div> : null;
    $[53] = handleVerTodas;
    $[54] = mostraVerTodas;
    $[55] = t18;
  } else {
    t18 = $[55];
  }
  let t19;
  if ($[56] !== t12 || $[57] !== t14 || $[58] !== t15 || $[59] !== t17 || $[60] !== t18) {
    t19 = <div className="w-[400px] overflow-hidden rounded-[16px] border border-neutral-200 bg-white shadow-lg">{t12}{t14}{t15}{t17}{t18}</div>;
    $[56] = t12;
    $[57] = t14;
    $[58] = t15;
    $[59] = t17;
    $[60] = t18;
    $[61] = t19;
  } else {
    t19 = $[61];
  }
  return t19;
}
function _temp(item) {
  return !item.lida;
}